// Mirrors docs/10-service-contracts.md's Response Envelope + HTTP status mapping.
export const ERROR_HTTP_STATUS = {
    unauthorized: 401,
    validationFailed: 400,
    notFound: 404,
    invalidState: 409,
    insufficientCredits: 409,
    forbidden: 403,
    aiUnavailable: 503,
    aiInvalidOutput: 502,
    rateLimited: 429,
    unexpected: 500,
};
/** Thrown by API service functions; the HTTP layer maps this to an ApiError envelope. */
export class CommandError extends Error {
    code;
    fieldErrors;
    constructor(code, message, fieldErrors) {
        super(message || code);
        this.name = "CommandError";
        this.code = code;
        this.fieldErrors = fieldErrors;
    }
}
export function notFound(message = "Record not found.") {
    return new CommandError("notFound", message);
}
export function validationFailed(message, fieldErrors) {
    return new CommandError("validationFailed", message, fieldErrors);
}
export function invalidState(message) {
    return new CommandError("invalidState", message);
}
export function insufficientCredits() {
    return new CommandError("insufficientCredits", "You need more credits for this AI task.");
}
export function aiInvalidOutput(message, fieldErrors) {
    return new CommandError("aiInvalidOutput", message, fieldErrors);
}
export function aiUnavailable(message = "AI service is unavailable.") {
    return new CommandError("aiUnavailable", message);
}
export function rateLimited(message = "Too many requests. Please slow down and try again shortly.") {
    return new CommandError("rateLimited", message);
}
export function forbidden(message = "You do not have access to this action.") {
    return new CommandError("forbidden", message);
}
/** Thrown by the web api client when a command/query response is a non-2xx ApiError. */
export class ApiRequestError extends Error {
    code;
    fieldErrors;
    requestId;
    constructor(body) {
        super(body.error.message);
        this.name = "ApiRequestError";
        this.code = body.error.code;
        this.fieldErrors = body.error.fieldErrors;
        this.requestId = body.requestId;
    }
}
